import { usePortalRoutes } from "apps/portal/src/hooks";
import { useTranslation } from "react-i18next";

import { RouteFeature, RouteLayout } from "../../../routes";
import PillTabsLayout from "../../molecules/PillTabsLayout";
import { SettingsContainer } from "../SettingsContainer";
import { PaymentMethodsTabInPerson } from "./PaymentMethodsTabInPerson";
import { PaymentMethodsTabOnline } from "./PaymentMethodsTabOnline";

export const PaymentMethodsTab = () => {
  const { createClubLink } = usePortalRoutes();

  const { t } = useTranslation();
  return (
    <SettingsContainer
      title={t("page.settings.tab.paymentMethods.title")}
      subTitle={t("page.settings.tab.paymentMethods.subTitle")}
    >
      <PillTabsLayout
        tabs={[
          {
            path: createClubLink(
              RouteLayout.Staff,
              `${RouteFeature.Settings}/payment-methods/online`,
            ),
            text: t("page.settings.tab.paymentMethods.online"),
            component: PaymentMethodsTabOnline,
          },
          {
            path: createClubLink(
              RouteLayout.Staff,
              `${RouteFeature.Settings}/payment-methods/in-person`,
            ),
            text: t("page.settings.tab.paymentMethods.inPerson"),
            component: PaymentMethodsTabInPerson,
          },
        ]}
      ></PillTabsLayout>
    </SettingsContainer>
  );
};
